import loadable from '@loadable/component';

export const ResetPasswordPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ResetPasswordPageContainer" */
      './ResetPasswordPageContainer.dynamic'
    ),
);
